import React from 'react';
import { Tooltip } from '_atoms';
import { Priority } from '_atoms/Priority';
import { Status } from '_atoms/Status';
import type { TableColumnType } from '_atoms/Table/types';
import type { TableSorting } from '_templates/AnalyticsCandidateInfo/constants';
import { headerCellRender } from '../../Jobs/constants';
import type { OpeningAnalyticsRow } from '../../utils';
import './style.scss';

type SetSorting = (sort: TableSorting) => void;

export const columns = (sort: TableSorting, setSorting: SetSorting): TableColumnType<OpeningAnalyticsRow>[] => [
  {
    title: headerCellRender('Priority', 'Priority', 'priority', sort, setSorting),
    dataIndex: 'priority',
    key: 'priority',
    width: 100,
    sorter: true,
    className: 'analytics-openings__priority',
    render: data => <Priority priority={data as import('_atoms/Priority').PriorityValue} />,
  },
  {
    title: headerCellRender('Job name', 'Job name', 'job_name', sort, setSorting),
    dataIndex: 'job_name',
    key: 'job_name',
    width: 200,
    sorter: true,
    className: 'analytics-openings__job-name',
    render: data => <Tooltip label={data as string}>{data as string}</Tooltip>,
  },
  {
    title: headerCellRender('Team Lead', 'Team Lead', 'team_lead', sort, setSorting),
    dataIndex: 'team_lead',
    key: 'team_lead',
    width: 200,
    sorter: true,
    className: 'analytics-openings__team-lead',
  },
  {
    title: headerCellRender('Expected date', 'Expected date', 'expected_date', sort, setSorting),
    dataIndex: 'expected_date',
    key: 'expected_date',
    width: 140,
    sorter: true,
    className: 'analytics-openings__expected-date',
  },
  {
    title: headerCellRender(
      'Required experience level',
      'Required experience level',
      'technical_level',
      sort,
      setSorting
    ),
    dataIndex: 'technical_level',
    key: 'technical_level',
    width: 180,
    sorter: true,
    className: 'analytics-openings__technical-level',
  },
  {
    title: headerCellRender('Status', 'Status', 'status', sort, setSorting),
    dataIndex: 'status',
    key: 'status',
    width: 160,
    sorter: true,
    className: 'analytics-openings__status',
    render: data => {
      const status = data as OpeningAnalyticsRow['status'];
      return <Status type={status.type}>{status.text}</Status>;
    },
  },
  {
    title: headerCellRender('Creation date', 'Creation date', 'creation_date', sort, setSorting),
    dataIndex: 'creation_date',
    key: 'creation_date',
    width: 140,
    sorter: true,
    className: 'analytics-openings__creation-date',
  },
  {
    title: headerCellRender('Office location', 'Office location', 'office_location', sort, setSorting),
    dataIndex: 'office_location',
    key: 'office_location',
    width: 180,
    sorter: true,
    className: 'analytics-openings__office-location',
    render: data => <Tooltip label={data as string}>{data as string}</Tooltip>,
  },
  {
    title: 'Closure date',
    dataIndex: 'closure_date',
    key: 'closure_date',
    width: 140,
    sorter: true,
    className: 'analytics-openings__closure-date',
  },
  {
    title: headerCellRender(
      'Potential candidates for the opening',
      'Potential candidates',
      'potential_candidates',
      sort,
      setSorting
    ),
    dataIndex: 'potential_candidates',
    key: 'potential_candidates',
    width: 180,
    sorter: true,
    className: 'analytics-openings__potential-candidates',
  },
  {
    title: headerCellRender(
      'Candidates assigned to the job',
      'Assigned candidates',
      'assigned_candidates_count',
      sort,
      setSorting
    ),
    dataIndex: 'assigned_candidates_count',
    key: 'assigned_candidates_count',
    width: 180,
    sorter: true,
    className: 'analytics-openings__assigned-candidates-count',
  },
];

export const COLUMNS_BE: Record<string, string> = {
  priority: 'Priority',
  job_name: 'Job name',
  team_lead: 'Team Lead',
  expected_date: 'Expected date',
  technical_level: 'Required technical level',
  status: 'Status',
  creation_date: 'Creation date',
  office_location: 'Office location',
  closure_date: 'Closure date',
  potential_candidates: 'Potential candidates for the opening',
  assigned_candidates_count: 'Candidates assigned to the job',
};
